import 'bootstrap/dist/css/bootstrap.min.css';
import { LuRefreshCw } from "react-icons/lu"; 
import '../../../styles/DailyGoalSettings.css';

export default function DailyGoalSettings({
GoalEnabled,
setGoalEnabled,
GoalMode,
setGoalMode,
GoalValue,
setGoalValue,
setRecalculate,
onRefresh
})

{

    return (
        <> 
        <div className="form-check form-switch">
            <input type="checkbox" className="form-check-input" 
            checked={GoalEnabled} onChange={(e)=>setGoalEnabled(e.target.checked)}/>
            <label className="form-check-label">Cele dzienne</label>
        </div>
            {GoalEnabled && (
                <div> 
                    <label className="radio-option">
                        <input type="radio" name="Daily-goal" checked={GoalMode == "Auto"}
                        value="Auto" onChange={(e)=>{setGoalMode(e.target.value); setRecalculate(true);}} /> Automatyczny 
                        <span className="question" data-bs-toggle="tooltip"
                        title="Cel dzienny przelicza się codziennie"
                        >
                        ?
                        </span>
                    </label> <br/>

                    <label className="radio-option">
                        <input type="radio" name="Daily-goal" checked={GoalMode == "Static"}
                        value="Static"
                        onChange={(e)=>{setGoalMode(e.target.value); setRecalculate(true);}}/> Stały 
                        <span className="question" data-bs-toggle="tooltip"
                        title="Cel dzienny oblicza się raz i zostaje bez zmian, chyba że sam go zaaktualizujesz"
                        >
                        ?
                        </span>
                        {GoalMode == "Static" && (
                            <span data-bs-toggle="tooltip"
                            title='Zaaktualizuj cel stały na podstawie aktualnych danych'> 
                                <LuRefreshCw onClick={onRefresh} className='refreshButton'/>
                            </span>
                        )}
                    </label> <br/>

                    <label className="radio-option">
                        <input type="radio" name="Daily-goal" checked={GoalMode == "Manual"}
                        value="Manual"
                        onChange={(e)=>{setGoalMode(e.target.value); setRecalculate(true);}} /> Ręczny 
                        <span className="question" data-bs-toggle="tooltip"
                        title="Ustawiasz cel samodzielnie i zmieniasz go kiedy chcesz"
                        >
                        ?
                        </span>
                            {GoalMode == "Manual" && (
                                <div> 
                                    Cel: <input type="number" className='chapterInput' value={GoalValue} onChange={(e)=>{
                                        setGoalValue(e.target.value);
                                    }}/>
                                </div>
                            )}
                    </label> <br/>
                </div>
            )}
        </>

    )
}